export type ApplyStatus =
  | "pending" | "claimed" | "applying"
  | "success" | "failed" | "rolled-back" | "held"
  | "awaiting-engine-update";

export interface ApplyProvenance {
  source: "button" | "policy";
  identity: string;
  at: string;
}

export interface ApplyRequest {
  schemaVersion: 1;
  target: string;
  provenance: ApplyProvenance;
  status: ApplyStatus;
  phase: string | null;
  claimedBy: string | null;
  leaseUntil: string | null;
  attempt: number;
  breaker: "none" | "rolled-back" | "held";
  result: { appliedVersion: string | null; error: string | null } | null;
  createdAt: string;
  updatedAt: string;
}

export const APPLY_REQUEST_PK = "system";
export const APPLY_REQUEST_RK = "apply-request";
export const IN_FLIGHT: ApplyStatus[] = ["claimed", "applying"];

export function isInFlight(status: ApplyStatus): boolean {
  return IN_FLIGHT.includes(status);
}

export function newIntent(target: string, provenance: ApplyProvenance, nowIso: string): ApplyRequest {
  return {
    schemaVersion: 1, target, provenance, status: "pending", phase: null,
    claimedBy: null, leaseUntil: null, attempt: 0, breaker: "none", result: null,
    createdAt: nowIso, updatedAt: nowIso,
  };
}

export function applyRequestToEntity(r: ApplyRequest): { partitionKey: string; rowKey: string; value: string; updatedAt: string } {
  return { partitionKey: APPLY_REQUEST_PK, rowKey: APPLY_REQUEST_RK, value: JSON.stringify(r), updatedAt: r.updatedAt };
}

export function entityToApplyRequest(e: { value: string }): ApplyRequest {
  return JSON.parse(e.value) as ApplyRequest;
}
